export default __webpack_public_path__ + "static/media/griffon2.7854fb70.jpg";